import { useEffect, useState } from "react";
import { SupplierGetSupplier } from "../../Api/Services";
import { useNavigate } from "react-router-dom";
import StoreImg from "../../assets/Icon/logistics.png";
import BankImg from "../../assets/Icon/icons8-bank-64.png";

function Supplier() {
  const [Data, setData] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const navigate = useNavigate();

  const start = async () => {
    try {
      const SupplierGetSuppliertData = await SupplierGetSupplier({});
      if (
        SupplierGetSuppliertData.status &&
        SupplierGetSuppliertData.status === 200
      ) {
        setData(SupplierGetSuppliertData.data.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const ShowStore = (id) => {
    navigate("/Panel/ShowSuppliers/Warehouse/" + id);
  };

  const ShowBank = (id) => {
    navigate("/Panel/ShowSuppliers/Bank/" + id);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          <div className="d-flex justify-content-center align-items-center w-100 p-2 tableC">
            <table className="table">
              <thead className="sticky-header">
                <tr className="trTable">
                  <th>نوع</th>
                  <th>نام</th>
                  <th>سیمبل</th>
                  <th>توضیحات</th>
                  <th>کد</th>
                  <th>پدر</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {Data.map((item, key) => (
                  <tr key={key}>
                    <td>{item.supplierTypeName}</td>
                    <td>{item.name}</td>
                    <td>{item.symbol}</td>
                    <td>{item.description}</td>
                    <td>{item.nationalId}</td>
                    <td>{item.parent?.name}</td>
                    <td className="td-actions">
                      <span
                        className="d-inline-block pointer me-2"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="مراکز"
                      >
                        <img
                          height="40"
                          src={StoreImg}
                          alt="مراکز"
                          onClick={() => {
                            ShowStore(item.id);
                          }}
                        />
                      </span>
                      <span
                        className="d-inline-block pointer me-2"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="بانک"
                      >
                        <img
                          height="40"
                          src={BankImg}
                          alt="بانک"
                          onClick={() => {
                            ShowBank(item.id);
                          }}
                        />
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Supplier;
